import { MapType } from "../types/dataTypes";
import { COLORS_BASE } from "./consts";
import { LAYER_IDS } from "./mapConsts";

export function toSlug(string: string | null) {
    if (!string) {
        return '';
    } else {
        return `${string.replace(/[\W_]+/g, '').toLowerCase()}`
    }
}

export function searchParamsObj(searchParams: URLSearchParams) {
    const object = Object.fromEntries(searchParams.entries());
    return object;
}

export function capitalizeWordsInString(string: string | undefined) {
    if (!string) { return 'No data' }
    const words = string.toLowerCase().split(" ");
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substring(1);
    }
    return words.join(" ");
};

export function returnNoData(string: string | undefined | null) {
    if (!string || string === 'null' || string.includes('null')) {
        return 'No data'
    } else return string
}

export function formatCoords(lon: number | string | null | undefined, lat: number | string | null | undefined) {
    if (!lon || !lat) { return "No coordinates provided" }
    return `${Number(lon).toFixed(4)}, ${Number(lat).toFixed(4)}`
}

export function formatScenarioNames(scenName: string | undefined) {
    if (!scenName) { return 'Unknown' }
    if (scenName === 'admin_selected') { return 'Manual' }
    return capitalizeWordsInString(scenName)
}

export const isPropValuesEqual = (subject: any, target: any, propNames: string[]) =>
    propNames.every(propName => subject[propName] === target[propName]);

export const filterObjectByDuplicateProp = (items: any, propNames: string[]) =>
    items.filter((item: any, index: any, array: any[]) =>
        index === array.findIndex(foundItem => isPropValuesEqual(foundItem, item, propNames))
    );

export function extractQuantiles(arr: number[]) {
    const arrAscending = (arr: number[]) => arr.sort((a, b) => (a - b));
    // const arrSum = (arr: number[]) => arr.reduce((a, b) => (a + b), 0);
    // const arrMean = (arr: number[]) => arrSum(arr) / arr.length;

    const quantile = (arr: number[], quan: number) => {
        const sorted = arrAscending(arr);
        const pos = (sorted.length - 1) * quan;
        const base = Math.floor(pos);
        const rest = pos - base;
        if (sorted[base + 1] !== undefined) {
            return Math.round((sorted[base] + rest * (sorted[base + 1] - sorted[base])) * 10) / 10
        } else {
            return Math.round(sorted[base] * 10) / 10;
        }
    }

    return {
        quan25: quantile(arr, 0.25),
        quan50: quantile(arr, 0.50),
        quan75: quantile(arr, 0.75)
    }
}

export function calcQuartile(arr: any[],q: number){
    var a = arr.slice();
    q = q/100; 
    function sortArr(arr: any[]){
      var ary = arr.slice();
      ary.sort(function(a,b){ return parseFloat(a) - parseFloat(b);});
      return ary;
    }
    const data = sortArr(a);
    var p = ((data.length) - 1) * q;
    var b = Math.floor(p);
    var remainder = p - b;
    if (data[b+1]!==undefined){
        return parseFloat(data[b]) + remainder * (parseFloat(data[b+1]) - parseFloat(data[b]));
    }else{
        return parseFloat(data[b]);
    }
}

export function createLegendFormat(arr: number[], type: 'losses' | 'voltage_drop') {
    const quants = extractQuantiles(arr);
    const legend = [
        { id: 1, min: 0.0, max: quants.quan25, text: `0 - ${quants.quan25}`, color: COLORS_BASE.BRAND.MAIN },
        { id: 2, min: quants.quan25, max: quants.quan50, text: `${quants.quan25} - ${quants.quan50}`, color: COLORS_BASE.BRAND.MAIN },
        { id: 3, min: quants.quan50, max: quants.quan75, text: ` ${quants.quan50} - ${quants.quan75}`, color: COLORS_BASE.BRAND.MAIN },
        { id: 4, min: quants.quan75, max: 1000, text: `> ${quants.quan75}`, color: COLORS_BASE.BRAND.MAIN }
    ]
    const lossesQuants = (quant: number) => (type === 'losses') ? quant / 1000 : quant

    const lineColor = [
        'case',
        ['>=', ['to-number', ['get', `${type}`]], lossesQuants(quants.quan75)],
        `${COLORS_BASE.BRAND.MAIN}`,
        ['>=', ['to-number', ['get', `${type}`]], lossesQuants(quants.quan50)],
        `${COLORS_BASE.BRAND.MAIN}`,
        ['>=', ['to-number', ['get', `${type}`]], lossesQuants(quants.quan25)],
        `${COLORS_BASE.BRAND.MAIN}`,
        ['>=', ['to-number', ['get', `${type}`]], 0],
        `${COLORS_BASE.BRAND.MAIN}`,
        `#000`,
    ]
    return { legend: legend, lineColor: lineColor }
}
